import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { Suspense, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import NavBar from './NavBar';
import TopBar from './TopBar';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: '90vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    paddingTop: 0,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.down('xs')]: {
      paddingTop: 10
    }
  }
}));

function Dashboard({ route }) {
  const classes = useStyles();
  const [openNavBar, setOpenNavBar] = useState(false);

  // const { oktaAuth, authState } = useOktaAuth();

  // useEffect(() => {
  //   if (
  //     (authState.accessToken.expiresAt - Math.trunc(Date.now() / 1000)) / 60 <
  //     30
  //   ) {
  //     const newToken = oktaAuth.getAccessToken();
  //     localStorage.setItem('token', newToken);
  //     sessionStorage.setItem('token', newToken);
  //   }
  // }, [authState]);

  return (
    <>
      <TopBar onOpenNavBar={() => setOpenNavBar(!openNavBar)} />
      <NavBar onClose={() => setOpenNavBar(!openNavBar)} open={openNavBar} />
      <div className={classes.container}>
        <div
          className={classes.content}
          style={{ paddingLeft: openNavBar ? 300 : 0 }}
        >
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
      </div>
    </>
  );
}

Dashboard.propTypes = {
  route: PropTypes.object
};

export default Dashboard;
